import { inject, Service } from '@angular/core';
import { HttpService } from '@data-services/http';

export interface ClientErrorLog {
  error: string;
  context: {
    url: string;
    timestamp: string;
    [key: string]: unknown;
  };
}

@Service()
export class ErrorLogService {
  private readonly http = inject(HttpService);

  async logErrorAsync(error: unknown): Promise<void> {
    try {
      await this.http.postObjectAsync<ClientErrorLog, void>('errors/client', {
        error: this.serializeError(error),
        context: {
          url: globalThis.location.href,
          timestamp: new Date().toISOString(),
        },
      });
    } catch {
      console.error('[ErrorLogService] Failed to log error to server.');
    }
  }

  private serializeError(error: unknown): string {
    if (!error) {
      return JSON.stringify({ message: 'Unknown error' });
    }

    if (error instanceof Error) {
      return JSON.stringify({
        name: error.name,
        message: error.message,
        stack: error.stack,
      });
    }

    if (typeof error === 'object') {
      try {
        return JSON.stringify(error);
      } catch {
        return '[Unserializable error object]';
      }
    }

    return JSON.stringify(error);
  }
}
